export default {
  'entityName': 'city',
  pagination: {
    'itemsPerPage': 10,
    'page': 1,
    'sortBy': 'id',
    'descending': true
  },
  filterStorage: {},
  'fields': [

    {
      value: 'cityName',
      text: 'City Name',
      'type': 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      'validators': [
        'required',
      ]
    },

    
    {
      value: 'areaName',
      text: 'Area Name',
      type: 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      default: null,
    },

    {
      value: 'localityName',
      text: 'Locality Name',
      type: 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      default: null,
    },


    {
      "value": "country_id",
      "text": "Country",
      "title" : "name",
      "type": "autocomplete",
      "table": {
          "sortable": true,
          "filter": true
      },
      "validators": [
          "required"
      ],
      
  },


    {
      value: 'state',
      text: 'State',
      type: 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      default: null,
    },


  ],
  actions: [
    'upsert','remove'
  ]
}
